<template>
    <div>
      <div id="container">
        <!-- Navigation -->
        <main>
            <CommonNavbar />
        </main>
  
        <!-- Divider -->
        <hr class="mt-0 mb-0" />
        <!-- End Divider -->
  
        <!-- BANNER -->
        <div style="width: 100%; overflow: hidden; margin-top: -3px; height: 400px;" id="mainbanner" data-aos="fade-down" data-aos-duration="1500">
          <div style="width: 100%; margin-right: auto; height: 100%;">
            <a  target="_blank" style="display: block; width: 100%; height: 100%;">
              <img class="banner-img" alt="Responsive image" :src="require('@/assets/society/isacibanner.jpg')" style="width: 100%; height: 100%; object-fit: cover;">
            </a>
          </div>
        </div>
        <div style="width: 100%; overflow: hidden; height: 300px;" id="mob">
          <div style="width: 100%; margin-right: auto; height: 100%;">
            <a  target="_blank" style="display: block; width: 100%; height: 100%;">
              <img class="banner-img" alt="Responsive image" :src="require('@/assets/society/isacibanner.jpg')" style="width: 100%; height: 100%; object-fit: cover;">
            </a>
          </div>
        </div>
  
        <br />

        <!-- Main Content -->
        <div class="container main-content">
          <div class="row">
            <div class="col-12">
              <div class="workshop-section" data-aos="fade-up" data-aos-duration="1500">
                <h3 class="section-title">The Asian and Oceania Workshop on Data, Inference and Security</h3>
                
                <div class="workshop-content">
                  <div class="workshop-header">
                    <div class="workshop-info-cards">
                      <div class="info-card">
                        <i class="fa-solid fa-calendar"></i>
                        <div>
                          <h6>Dates</h6>
                          <p>14 – 16 November 2025</p>
                        </div>
                      </div>
                      <div class="info-card">
                        <i class="fa-solid fa-map-marker-alt"></i>
                        <div>
                          <h6>Location</h6>
                          <p>Penang, Malaysia</p>
                        </div>
                      </div>
                      <div class="info-card">
                        <i class="fa-solid fa-building"></i>
                        <div>
                          <h6>Organised by</h6>
                          <p>International Society for Applied and Computational Imaging (ISACI)</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="workshop-description">
                    <h5>Overview</h5>
                    <p>The Asian and Oceania Workshop on Data, Inference and Security brings together researchers, scholars, and professionals across disciplines to explore the latest developments in data-driven modelling, computational inference, and information security.</p>
                    <p>This workshop serves as a collaborative platform for the academic community in the Asia–Pacific and Oceania regions, fostering dialogue, exchange of ideas, and partnership opportunities in applied and computational imaging.</p>
                  </div>

                  <div class="workshop-format">
                    <h5>Programme</h5>
                    <div class="programme-list">
                      <div class="programme-item">
                        <i class="fa-solid fa-calendar-day"></i>
                        <div>
                          <strong>Day 1 (14 Nov)</strong>
                          <p>Arrival and Registration</p>
                        </div>
                      </div>
                      <div class="programme-item">
                        <i class="fa-solid fa-calendar-day"></i>
                        <div>
                          <strong>Day 2 (15 Nov)</strong>
                          <p>Technical Sessions and Visit to Universiti Sains Malaysia (USM)</p>
                        </div>
                      </div>
                      <div class="programme-item">
                        <i class="fa-solid fa-calendar-day"></i>
                        <div>
                          <strong>Day 3 (16 Nov)</strong>
                          <p>Workshop Sessions and Closing Discussion</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="workshop-participation">
                    <h5>Registration</h5>
                    <div class="registration-info">
                      <!-- <div class="registration-item">
                        <i class="fa-solid fa-dollar-sign"></i>
                        <div>
                          <strong>Fee</strong>
                          <p>SGD 300 per participant</p>
                        </div>
                      </div> -->
                      <div class="registration-item">
                        <i class="fa-solid fa-user-plus"></i>
                        <div>
                          <strong>Registration</strong>
                          <p>Please register <router-link to="/registration">here</router-link>.</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="workshop-format">
                    <h5>Contact</h5>
                    <div class="contact-info">
                      <div class="contact-item">
                        <i class="fa-solid fa-envelope"></i>
                        <div>
                          <strong>Email</strong>
                          <p><a href="mailto:isaci.contact@gmail.com" target="_blank">isaci.contact@gmail.com</a></p>
                        </div>
                      </div>
                      <p class="contact-enquiry">For all workshop-related enquiries, please reach out to the email above.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <br />
        <br />
        <br />
      </div>
  
      <!-- Footer -->
      <TheFooter />
    </div>
</template>

<script>
// import CommonFooter from '@/components/CommonFooter.vue'
import TheFooter from '@/components/TheFooter.vue'
import CommonNavbar from '@/components/CommonNavbar.vue'

export default {
  name: 'Information',
  components: {
    CommonNavbar,
    TheFooter
  },
  mounted() {
    // Initialize AOS
    if (window.AOS) {
      window.AOS.init()
    }
  }
}
</script>

<style scoped>
/* Main Content */
.main-content {
  padding: 20px 0;
  max-width: 1300px !important;
}

/* Workshop Section */
.workshop-section {
  background: white;
  border-radius: 8px;
  padding: 40px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  margin-top: 0px;
  margin-bottom: 20px;
  border: 1px solid #e0e0e0;
}

.workshop-content {
  max-width: 100%;
}

.workshop-header {
  margin-bottom: 35px;
}

.workshop-info-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 25px;
}

.info-card {
  display: flex;
  align-items: center;
  background: white;
  padding: 25px;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  border-top: 4px solid #000E70;
  transition: all 0.3s ease;
  box-shadow: 0 1px 5px rgba(0,0,0,0.05);
}

.info-card:hover {
  transform: scale(1.02);
  box-shadow: 0 5px 18px rgba(0,14,112,0.2);
  border-top-color: #073787;
}

.info-card i {
  font-size: 28px;
  color: white;
  background: linear-gradient(135deg, #000E70, #073787);
  width: 50px;
  height: 50px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  flex-shrink: 0;
  box-shadow: 0 3px 8px rgba(0,14,112,0.25);
}

.info-card h6 {
  margin: 0 0 5px 0;
  font-size: 14px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-card p {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
}

.section-title {
  text-align: center;
  color: #000E70;
  font-size: 2.2rem;
  font-weight: bold;
  margin-bottom: 35px;
  position: relative;
  padding-bottom: 15px;
}

.section-title::before {
  content: '';
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 120px;
  height: 3px;
  /* background: linear-gradient(90deg, #000E70, #073787); */
}

.workshop-description {
  background: white;
  padding: 35px;
  border-radius: 8px;
  margin-bottom: 35px;
  border-left: 5px solid #000E70;
  box-shadow: 0 3px 15px rgba(0,14,112,0.1);
}

.workshop-description h5 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 20px;
  text-align: left;
  padding-bottom: 12px;
  border-bottom: 2px solid #e9ecef;
  color: #000E70;
}

.workshop-description p {
  font-size: 18px;
  line-height: 1.8;
  margin: 0 0 18px 0;
  font-weight: 400;
  text-align: start;
  color: #333;
}

.workshop-description p:last-child {
  margin-bottom: 0;
}

.workshop-format,
.workshop-participation {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 12px;
  margin-bottom: 25px;
  border-left: 4px solid #000E70;
}

.workshop-format h5,
.workshop-participation h5 {
  color: #000E70;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  position: relative;
}

.workshop-format h5::after,
.workshop-participation h5::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #000E70, #073787);
  border-radius: 2px;
}

/* Programme List */
.programme-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.programme-item {
  display: flex;
  align-items: flex-start;
  background: white;
  padding: 18px;
  border-radius: 10px;
  border: 2px solid #e9ecef;
  transition: all 0.3s ease;
}

.programme-item:hover {
  border-color: #000E70;
  transform: translateX(5px);
  box-shadow: 0 4px 15px rgba(0,14,112,0.1);
}

.programme-item i {
  font-size: 22px;
  color: #000E70;
  margin-right: 15px;
  margin-top: 2px;
  width: 25px;
  text-align: center;
}

.programme-item strong {
  display: block;
  font-size: 17px;
  font-weight: 600;
  color: #000E70;
  margin-bottom: 5px;
}

.programme-item p {
  margin: 0;
  font-size: 16px;
  color: #333;
  line-height: 1.5;
}

/* Registration Info */
.registration-info {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.registration-item {
  display: flex;
  align-items: flex-start;
  background: white;
  padding: 18px;
  border-radius: 10px;
  border: 2px solid #e9ecef;
  transition: all 0.3s ease;
}

.registration-item:hover {
  border-color: #000E70;
  transform: translateX(5px);
  box-shadow: 0 4px 15px rgba(0,14,112,0.1);
}

.registration-item i {
  font-size: 22px;
  color: #000E70;
  margin-right: 15px;
  margin-top: 2px;
  width: 25px;
  text-align: center;
}

.registration-item strong {
  display: block;
  font-size: 17px;
  font-weight: 600;
  color: #000E70;
  margin-bottom: 5px;
}

.registration-item p {
  margin: 0;
  font-size: 16px;
  color: #333;
  line-height: 1.5;
}

.registration-item a,
.registration-item ::v-deep a {
  color: #000E70;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}

.registration-item a:hover,
.registration-item ::v-deep a:hover {
  color: #073787;
  text-decoration: underline;
}

/* Contact Info */
.contact-info {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  background: white;
  padding: 18px;
  border-radius: 10px;
  border: 2px solid #e9ecef;
  transition: all 0.3s ease;
}

.contact-item:hover {
  border-color: #000E70;
  transform: translateX(5px);
  box-shadow: 0 4px 15px rgba(0,14,112,0.1);
}

.contact-item i {
  font-size: 22px;
  color: #000E70;
  margin-right: 15px;
  margin-top: 2px;
  width: 25px;
  text-align: center;
}

.contact-item strong {
  display: block;
  font-size: 17px;
  font-weight: 600;
  color: #000E70;
  margin-bottom: 5px;
}

.contact-item p {
  margin: 0;
  font-size: 16px;
  color: #333;
  line-height: 1.5;
}

.contact-item a {
  color: #000E70;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}

.contact-item a:hover {
  color: #073787;
  text-decoration: underline;
}

.contact-enquiry {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  margin: 10px 0 0 0;
  font-style: italic;
}

/* Responsive Design */
@media (max-width: 768px) {
  .workshop-info-cards {
    grid-template-columns: 1fr;
  }
  
  .section-title {
    font-size: 1.5rem;
  }
  
  .workshop-description h5 {
    font-size: 20px;
  }
  
  .workshop-description p {
    font-size: 16px;
  }
  
  .workshop-format h5,
  .workshop-participation h5 {
    font-size: 18px;
  }
  
  .programme-item,
  .registration-item,
  .contact-item {
    padding: 15px;
  }
  
  .programme-item strong,
  .registration-item strong,
  .contact-item strong {
    font-size: 16px;
  }
  
  .programme-item p,
  .registration-item p,
  .contact-item p {
    font-size: 15px;
  }
}

@media (max-width: 576px) {
  .workshop-section {
    padding: 20px;
  }
  
  .section-title {
    font-size: 1.3rem;
  }
  
  .info-card p {
    font-size: 16px;
  }
}
</style>

